import { RULES_2026 as R } from "@ftr/tax-core";
import { Link } from "../lib/router.tsx";
import { daysUntil, shortDate, todayIso } from "../lib/format.ts";

/** "Apr 15" inside the tax year, "Jan 15, 2027" for the payment that falls in the next one. */
function dueLabel(iso: string): string {
  return iso.startsWith(`${R.taxYear}-`) ? shortDate(iso).replace(/, \d{4}$/, "") : shortDate(iso);
}

/**
 * The four estimated payment dates for the tax year, under the hero. Dates come from the rules file; only "today"
 * comes from the viewer's clock. The next one is marked with a countdown, earlier ones read as passed.
 */
export function DueDates({ href }: { href: string }) {
  const today = todayIso();
  const dates = R.estimatedTax.dueDates;
  const next = dates.find((d) => d >= today);
  return (
    <section className="due" aria-label={`${R.taxYear} estimated payment dates`}>
      <div className="shell due-inner">
        <span className="due-title">{R.taxYear} estimated payments</span>
        <ol className="due-list">
          {dates.map((d) => {
            const days = d === next ? daysUntil(d, today) : null;
            return (
              <li key={d} className={d === next ? "due-date is-next" : d < today ? "due-date is-past" : "due-date"} aria-current={d === next ? "date" : undefined}>
                <time dateTime={d}>{dueLabel(d)}</time>
                {d < today ? <span className="due-note">passed</span> : null}
                {days !== null ? <span className="due-note">next · {days === 0 ? "today" : `${days} day${days === 1 ? "" : "s"}`}</span> : null}
              </li>
            );
          })}
        </ol>
        <Link href={href} className="due-go">
          Work out my payment →
        </Link>
      </div>
    </section>
  );
}
